import { render } from "./PreviewComp.vue?vue&type=template&id=4a77b5e6&ts=true"
import script from "./PreviewComp.vue?vue&type=script&lang=ts"
export * from "./PreviewComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__